export default "__VITE_ASSET__03ec3301__"